<template>
    <div ref="calculationResult" class="calculation-result">
        <h3 class="result-title">Your Projected savings</h3>
        <p class="result-description">Paying off your student loans early can help you to save time and money. </p>
        <div class="result-outer">
            <div class="calculation-output">
                <div class="calculation-output-inner">
                    <div class="calculation-title-wrapper">
                        <p class="calculation-title">
                            <img src="../../../assets/images/calendar-icon.svg" />
                            <span>Time Saved</span>
                        </p>
                    </div>
                    <h3 class="calculation-amount">{{ convertYearMonthStringCall(calculatedResult.term.savings, 'medium') }}</h3>
                </div>
                <p class="calculation-text">Your loan could be paid off this far ahead of schedule.</p>
            </div>
            <div class="calculation-output">
                <div class="calculation-output-inner">
                    <div class="calculation-title-wrapper">
                        <p class="calculation-title">
                            <img src="../../../assets/images/personal-loan-icon.svg" />
                            <span>Money Saved</span>
                        </p>
                    </div>
                    <h3 class="calculation-amount">{{ convertAccountFormat(calculatedResult.balanceAmount.savings) }}</h3>
                </div>
                <p class="calculation-text">You could keep this much more for your hard earned cash.</p>
            </div>
            <div v-show="ShowAdvancedOptions" class="advanced-options" :class="{ 'all-options': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                <div class="calculation-output">
                    <p class="view-more-title">your saving calculations</p>
                    <div class="monthy-payment-change-wrapper">
                        <p class="monthy-payment-change-title">
                            <span>Here's what happens by changing your monthly payment from</span>
                        </p>
                        <h4 class="monthy-payment-change-amount">{{ convertAccountFormat(calculatedResult.monthlyPayment.old) }} to {{ convertAccountFormat(calculatedResult.monthlyPayment.new) }}</h4>
                    </div>
                    <div class="card-results-block">
                        <ul class="calc-results-block">
                            <li>
                                <div class="calc-block">
                                    <label class="title">Time</label>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ originalLoan }}</span>
                                        <span class="calc-result-value">{{ convertYearMonthStringCall(calculatedResult.term.old, 'short') }}</span>
                                    </div>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ increasedPayment }}</span>
                                        <span class="calc-result-value">-{{ convertYearMonthStringCall(calculatedResult.term.new, 'short') }}</span>
                                    </div>
                                    <div class="calc-value green-bg">
                                        <span class="calc-result-title bold-text">TOTAL TIME SAVED:</span>
                                        <span class="calc-result-value bold-text">{{ convertYearMonthStringCall(calculatedResult.term.savings, 'short') }}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="calc-block">
                                    <label class="title">Interest</label>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ originalLoan }}</span>
                                        <span class="calc-result-value">{{ convertAccountFormat(calculatedResult.interest.old) }}</span>
                                    </div>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ increasedPayment }}</span>
                                        <span class="calc-result-value">-{{ convertAccountFormat(calculatedResult.interest.new) }}</span>
                                    </div>
                                    <div class="calc-value green-bg">
                                        <span class="calc-result-title bold-text">TOTAL INTEREST SAVED:</span>
                                        <span class="calc-result-value bold-text">{{ convertAccountFormat(calculatedResult.interest.savings) }}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="calc-block">
                                    <label class="title">Loan Total</label>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ originalLoan }}</span>
                                        <span class="calc-result-value">{{ convertAccountFormat(calculatedResult.balanceAmount.old) }}</span>
                                    </div>
                                    <div class="calc-value">
                                        <span class="calc-result-title">{{ increasedPayment }}</span>
                                        <span class="calc-result-value">-{{ convertAccountFormat(calculatedResult.balanceAmount.savings) }}</span>
                                    </div>
                                    <div class="calc-value green-bg">
                                        <span class="calc-result-title bold-text">NEW LOAN TOTAL:</span>
                                        <span class="calc-result-value bold-text">{{ convertAccountFormat(calculatedResult.balanceAmount.new) }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="view-details">
                <label class="show-hide-options" :class="{ 'hide-xs': ShowAdvancedOptions}" @click="viewMoreClick()"> {{ !ShowAdvancedOptions ? "View" : "Hide" }} Details
                    <span class="lt-icons" :class="{ 'lt4-ChevronUp': ShowAdvancedOptions, 'lt4-ChevronDown': !ShowAdvancedOptions}"></span>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import helperstudentloanpayoff from '../helpers/studentloanpayoff';

    export default {
        props: ['showResult', 'originalLoan', 'increasedPayment', 'showAdvancedOptions'],
        data() {
            return {
                ShowAdvancedOptions: this.showAdvancedOptions,
            };
        },
        computed: {
            calculatedResult() {
                return this.showResult;
            },
        },
        methods: {
            convertYearMonthStringCall(monthYearValue, format = 'long') {
                return helperstudentloanpayoff.convertYearMonthString(monthYearValue, format);
            },
            convertAccountFormat($value) {
                return Accounting.formatMoney($value, { precision: 0 });
            },
            viewMoreClick() {
                if (this.ShowAdvancedOptions) {
                    this.$refs.calculationResult.scrollIntoView(true);
                }
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },
        },
    };
</script>
